var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"region-box"},[_c('el-cascader',{ref:"regionCascader",attrs:{"options":_vm.options,"change-on-select":true,"show-all-levels":true,"filterable":"","props":_vm.props,"placeholder":_vm.placeholder,"clearable":true},on:{"change":_vm.regionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }